export type FullJitterBackoffInput = {
  attempt: number;
  baseDelayMs: number;
  maxDelayMs: number;
};

export const getFullJitterBackoffDelayMs = ({
  attempt,
  baseDelayMs,
  maxDelayMs,
}: FullJitterBackoffInput): number => {
  const cappedExponentialDelay = Math.min(baseDelayMs * 2 ** attempt, maxDelayMs);
  return Math.floor(Math.random() * (cappedExponentialDelay + 1));
};
